export const manifest = {
  screens: {
    scr_hx74sa: { name: "Home", route: "/", position: {"x":160,"y":5780} },
    scr_qoi4tf: { name: "Areas we cover", route: "/areas-we-cover", position: {"x":160,"y":1820} },
    scr_q5l3yx: { name: "Birmingham Location", route: "/locations/birmingham", state: {"slug":"birmingham"}, position: {"x":1560,"y":1820} },
    scr_ynyrd6: { name: "Coventry Location", route: "/locations/coventry", state: {"slug":"coventry"}, position: {"x":2960,"y":1820} },
    scr_d9awtu: { name: "Installation Service", route: "/services/installation", position: {"x":160,"y":3800} },
    scr_bmf8uo: { name: "Maintenance Service", route: "/services/maintenance", position: {"x":1560,"y":3800} },
    scr_jdthl6: { name: "TM44 Compliance", route: "/services/tm44", position: {"x":2960,"y":3800} },
  },
  sections: {
    sec_ja1p1y: { name: "Locations browsing", x: 0, y: 1600, width: 4320, height: 1180 },
    sec_ao6bpo: { name: "Services", x: 0, y: 3580, width: 4320, height: 1180 },
    sec_kfi690: { name: "Home", x: 0, y: 5560, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ja1p1y", children: [
      { kind: "screen", id: "scr_qoi4tf" },
      { kind: "screen", id: "scr_q5l3yx" },
      { kind: "screen", id: "scr_ynyrd6" },
    ] },
    { kind: "section", id: "sec_ao6bpo", children: [
      { kind: "screen", id: "scr_d9awtu" },
      { kind: "screen", id: "scr_bmf8uo" },
      { kind: "screen", id: "scr_jdthl6" },
    ] },
    { kind: "section", id: "sec_kfi690", children: [
      { kind: "screen", id: "scr_hx74sa" },
    ] },
  ],
}
